export default "__VITE_ASSET__DT_bjRpD__"